import React, { useState, useEffect } from "react";
import { Table, Input, Button, Popconfirm, Space } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

const TableRelationships = ({
    visible,
    onClose,
    evl_relationships,
    handleDeleteRelationship,
    handleEditRelationship,
    loading = false,
    pagination = null,
    onPageChange,
    serverPagination = false,
    isLinks = false,
    evl_id
}) => {
    const [searchText, setSearchText] = useState("");

    const rootUrl = window.location.origin;

    const filteredData = evl_relationships.filter((item) =>
        Object.values(item).some((val) =>
            String(val).toLowerCase().includes(searchText.toLowerCase())
        )
    );

    const baseColumns = [
        {
            title: "Evaluador",
            children: [
                {
                    title: "Identificación",
                    dataIndex: "evr_evaluator",
                    key: "evr_evaluator",
                },
                {
                    title: "Nombre completo",
                    dataIndex: "evr_evaluator_fullname",
                    key: "evr_evaluator_fullname",
                },
                {
                    title: "Cargo",
                    dataIndex: "evr_evaluator_job_title",
                    key: "evr_evaluator_job_title",
                },
            ]
        },
        {
            title: "Evaluado",
            children: [
                {
                    title: "Identificación",
                    dataIndex: "evr_evaluated",
                    key: "evr_evaluated",
                },
                {
                    title: "Nombre completo",
                    dataIndex: "evr_evaluated_fullname",
                    key: "evr_evaluated_fullname",
                },
                {
                    title: "Cargo",
                    dataIndex: "evr_evaluated_job_title",
                    key: "evr_evaluated_job_title",
                },
            ]
        },
        {
            title: "Tipo de Relación",
            dataIndex: "evr_type",
            key: "evr_type",
        }
    ];

    const actionColumn = {
        title: "Acciones",
        key: "actions",
        align: "center",
        render: (_, record) => (
            <Space size="small">
                <Button
                    icon={<EditOutlined />}
                    onClick={() => handleEditRelationship?.(record)}
                />
                <Popconfirm
                    title="¿Seguro que deseas eliminar esta relación?"
                    onConfirm={() => handleDeleteRelationship(record.evr_uid || record.evr_id)}
                    okText="Sí"
                    cancelText="No"
                >
                    <Button danger icon={<DeleteOutlined />} />
                </Popconfirm>
            </Space>
        ),
    }

    const columns = [...baseColumns, actionColumn];

    return (
        <>
            <Input
                placeholder="Buscar por evaluado, evaluador o tipo de relación"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                style={{ marginBottom: 16 }}
                allowClear
            />
            <Table
                className="custom-green-table"
                size="small"
                columns={columns}
                dataSource={filteredData}
                loading={loading}
                rowKey={(record) => record.evr_uid || record.evr_id}
                pagination={serverPagination
                    ? {
                        current: pagination?.page || 1,
                        pageSize: pagination?.page_size || 20,
                        total: pagination?.total || 0,
                        showSizeChanger: true,
                        pageSizeOptions: ['10', '20', '50', '100'],
                        position: ["bottomRight"],
                        onChange: (page, pageSize) => onPageChange?.(page, pageSize),
                    }
                    : { pageSize: 10, position: ["bottomRight"] }}
                scroll={{ x: "max-content" }}
            />            
        </>
    );
};

export default TableRelationships;
